var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChild(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10.5001C16.7517 10.5001 14.0882 13.1696 14.0882 16.5001C14.0882 19.8306 16.7517 22.5001 20 22.5001C23.2483 22.5001 25.9118 19.8306 25.9118 16.5001C25.9118 13.1696 23.2483 10.5001 20 10.5001ZM11.0882 16.5001C11.0882 11.5464 15.0615 7.50014 20 7.50014C24.9385 7.50014 28.9118 11.5464 28.9118 16.5001C28.9118 21.4539 24.9385 25.5001 20 25.5001C15.0615 25.5001 11.0882 21.4539 11.0882 16.5001ZM13.7176 30.5001C12.535 30.5001 11.5141 31.3288 11.271 32.4861L10.468 36.3085C10.2976 37.1193 9.50233 37.6384 8.69161 37.4681C7.88088 37.2978 7.36172 36.5025 7.53204 35.6917L8.33507 31.8694C8.86998 29.3232 11.1158 27.5001 13.7176 27.5001H26.2824C28.8842 27.5001 31.13 29.3232 31.6649 31.8694L32.468 35.6917C32.6383 36.5025 32.1191 37.2978 31.3084 37.4681C30.4977 37.6384 29.7024 37.1193 29.532 36.3085L28.729 32.4861C28.4859 31.3288 27.465 30.5001 26.2824 30.5001H13.7176Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChild);
export default __webpack_public_path__ + "static/media/child.54fbf88c0ad30f25434be4a838aada66.svg";
export { ForwardRef as ReactComponent };